import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import useStyles from './styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormElements from '../FormCreator/FormElements';
import { HiddenForRoles } from '../../hocs';
import { useIntl } from 'react-intl';

const FilterComponent = props => {
  const { filters, getFilters, title, initialKeyValues, noTitle } = props;
  const classes = useStyles();
  const [keyValues, setKeyValues] = useState(initialKeyValues);
  const intl = useIntl();

  const handleSubmit = () => {
    getFilters(keyValues);
  };

  const resetKeyValues = () => {
    setKeyValues({});
    getFilters({});
  };

  const setFilterKeyValue = e => {
    const { value, name, checked } = e.target;
    const finalValue = e.target.type === 'checkbox' ? checked : value;
    setKeyValues({ ...keyValues, [name]: finalValue });
  };

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      handleSubmit();
    }
  };

  useEffect(() => {
    document.addEventListener("ClearFilterEvent", resetKeyValues.bind(this));
    return () => {
      document.removeEventListener("ClearFilterEvent", resetKeyValues.bind(this));
    }
  }, []);

  if (!filters.length) {
    return null;
  }

  return (
    <div className={classes.root}>
      {
        !noTitle && (
          <Typography className={classes.title} variant="h3">
        {
          title
            ? title
            : intl.formatMessage({id: "app.components.filters.title", defaultMessage: "Table Data Filters"})
          }
          </Typography>
        )
      }
      <Grid container spacing={1}>
        {filters.map((filterObj, index) => (
          <Grid key={index} item xs>
            <FormElements
              allowNone={filterObj.allowNone}
              disabledForRoles={filterObj.disabledForRoles}
              hiddenForRoles={filterObj.hiddenForRoles}
              label={filterObj.label}
              name={filterObj.key}
              onChange={setFilterKeyValue}
              type={filterObj.type}
              value={keyValues[filterObj.key]}
              values={filterObj.validValues}
              onKeyDown={handleKeyPress}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={1} className={classes.buttonsWrapper}>
        <Grid item xs>
          <Button onClick={handleSubmit} variant="outlined" className={classes.button}>
            {intl.formatMessage({id: "app.components.filters.apply", defaultMessage: "Apply"})}
          </Button>
          <Button onClick={resetKeyValues} variant="outlined" className={classes.button}>
            {intl.formatMessage({id: "app.components.filters.clear", defaultMessage: "Clear"})}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

FilterComponent.propTypes = {
  filters: PropTypes.array,
  getFilters: PropTypes.func,
  title: PropTypes.string,
  noTitle: PropTypes.bool,
  initialKeyValues: PropTypes.object
};

FilterComponent.defaultProps = {
  filters: [],
  getFilters: () => null,
  hiddenForRoles: [],
  initialKeyValues: {},
  noTitle: false
};

export default HiddenForRoles(FilterComponent);
